
export type ProjectListResponsePageAllOfThreeContentItemBasicInfoVisibility = typeof ProjectListResponsePageAllOfThreeContentItemBasicInfoVisibility[keyof typeof ProjectListResponsePageAllOfThreeContentItemBasicInfoVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectListResponsePageAllOfThreeContentItemBasicInfoVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  LINK_ONLY: 'LINK_ONLY',
} as const;
